module.exports = __webpack_public_path__ + "static/media/4-star.a3a76b21.png";